<div class="card shadow-sm mb-5">
  <div class="card-header text-white">
    <h3 class="mb-0"><i class="fa fa-money-check-alt"></i>Consultas</h3>
  </div>

  <div class="card-body">
    <div class="col-md-6 form-group mb-4">
        <label class="form-label fw-semibold">Tipo de Consulta</label>
        <select class="form-select" [(ngModel)]="queryId">
        <option [ngValue]="null" disabled>Seleccione una Consulta</option>
        <option [ngValue]="1">Consulta de Movimientos</option>
        <option [ngValue]="2">Consulta de Estado de Cuenta</option>
        <!-- <option [ngValue]="3">Consulta de Comprobante</option> -->
        <!-- <option [ngValue]="4">Consulta de Notas de Debito y Credito (Voucher)</option> -->
        <!-- <option [ngValue]="5">Consulta de Movimientos MT940</option> -->
        </select>
    </div>
    <div class="row">
        <app-bam-query-movements *ngIf="queryId==1"/>
        <app-bam-query-account-status *ngIf="queryId==2"/>
        <!-- <app-bam-query-voucher *ngIf="queryId==4"/> -->
        <!-- <app-bam-query-mt940 *ngIf="queryId==5"/> -->
    </div>
  </div>
</div>
